<template>
  <v-dialog v-model="open" persistent max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        block
        color="red darken-1"
        class="lead-bottom-control-panel__btn white--text"
        dark
        v-bind="attrs"
        v-on="on"
      >
        <v-icon color="white">mdi-delete</v-icon>
        <span class="lead-bottom-control-panel__item-text">Delete</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Delete lead</span>
      </v-card-title>
      <v-card-text>Are you sure want to delete this lead?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="() => (open = false)">
          Close
        </v-btn>
        <v-btn color="red darken-1" @click="deleteLead" class="white--text">
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "DeleteForm",
  data() {
    return {
      open: false,
    };
  },
  props: {
    lead_id: Number,
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),
    deleteLead() {
      this.$axios
        .post("/lead/delete", {
          lead_id: this.lead_id,
        })
        .then((res) => {
          this.$router.replace("/life");
          this.showHandlerSnackbar({
            color: res.data.status,
            text: res.data.message,
            show: true,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style>
</style>